module.exports = __webpack_public_path__ + "img/garden-menu.847e21d6.png";